import { cineamoApiClient } from '../../apiClient';
import { UrlQueryParameter, buildUrlQuery } from '../../helpers/url-query-helper';
import { SeatLockDto } from '../../models/seat-lock/SeatLockDto.types';
import { SeatLockInputDto } from '../../models/seat-lock/SeatLockInputDto';
import { ApiErrorResponse } from '../../types/ApiErrorResponse.types';
import { SeatLockListResponse } from '../../types/ApiListResponse.types';
import { ApiResponse } from '../../types/ApiResponse.types';

// <------------------------ SeatLocks ----------------------->

export type GetSeatLocksParams = UrlQueryParameter & {
    cinemaId?: number;
    cinemaRoomId?: number;
    showingId?: number;
    seatIds?: number[];
    isActive?: boolean;
};

export async function getSeatLocks(
    cartUuid: string,
    params?: GetSeatLocksParams
): Promise<ApiResponse<SeatLockListResponse> | null> {
    return cineamoApiClient
        .get<ApiResponse<SeatLockListResponse>>(`/carts/${cartUuid}/seat-locks${buildUrlQuery(params)}`, {
            session: {
                scheme: 'CineamoCart',
                accessToken: cartUuid
            }
        })
        .then((response) => response.data)
        .catch(() => null);
}

export type GetShowingSeatLocksParams = UrlQueryParameter & {
    isActive?: boolean;
};

export async function getShowingSeatLocks(
    showingId: number,
    params?: GetShowingSeatLocksParams
): Promise<ApiResponse<SeatLockListResponse> | null> {
    return cineamoApiClient
        .get<ApiResponse<SeatLockListResponse>>(`/showings/${showingId}/seat-locks${buildUrlQuery(params)}`)
        .then((response) => response.data)
        .catch(() => null);
}

export async function createSeatLock(
    seatLock: SeatLockInputDto,
    cartUuid: string
): Promise<ApiResponse<SeatLockDto> | ApiErrorResponse<SeatLockInputDto>> {
    return cineamoApiClient
        .post(`/carts/${cartUuid}/seat-locks`, seatLock, {
            session: {
                scheme: 'CineamoCart',
                accessToken: cartUuid
            }
        })
        .then((response) => response.data)
        .catch((error) => error);
}

export async function setSeatLockBulk(
    seatLocks: SeatLockInputDto[],
    cartUuid: string
): Promise<ApiResponse<SeatLockListResponse> | ApiErrorResponse<SeatLockInputDto>> {
    return cineamoApiClient
        .put(`/carts/${cartUuid}/seat-locks`, seatLocks, {
            session: {
                scheme: 'CineamoCart',
                accessToken: cartUuid
            }
        })
        .then((response) => response.data)
        .catch((error) => error);
}

export async function updateSeatLock(
    seatLock: SeatLockInputDto,
    cartUuid: string
): Promise<ApiResponse<SeatLockDto> | ApiErrorResponse<SeatLockInputDto>> {
    return cineamoApiClient
        .patch(`/carts/${cartUuid}/seat-locks/${seatLock.id}`, seatLock, {
            session: {
                scheme: 'CineamoCart',
                accessToken: cartUuid
            }
        })
        .then((response) => response.data)
        .catch((error) => error);
}

export async function deleteSeatLockById(seatLockId: number, cartUuid: string): Promise<boolean> {
    return cineamoApiClient
        .delete(`/carts/${cartUuid}/seat-locks/${seatLockId}`, {
            session: {
                scheme: 'CineamoCart',
                accessToken: cartUuid
            }
        })
        .then((response) => response.status === 204)
        .catch(() => false);
}
